import { Suspense } from 'react';
import cc from 'classcat';
import { Navigate, Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { selectAuth, selectUserRole } from '../../store/slices/auth.slice';
import Navigation from '../Navigation';
import { Header } from '../Header';
import { RoleTypeEnum } from '../../commonTypes/user.types';
import { selectSideBarCollapsed } from '../../store/slices/navigation/navigation.slice';
import { MixerLoader } from '../Common';

const Layout = () => {
    const collapsed = useSelector(selectSideBarCollapsed);
    const userRole = useSelector(selectUserRole);
    const user = useSelector(selectAuth);

    if (user.userSub !== '' && userRole.name === RoleTypeEnum.BASIC) {
        return <Navigate to={'/get-started'} />;
    }

    if (user.userSub === '') {
        return <></>;
    }

    return (
        <div className="layout-wrapper">
            <Navigation />
            <Header />
            <div className={cc(['page-wrapper', { 'page-wrapper--extended': collapsed }])}>
                <Suspense fallback={<MixerLoader position="centerOnParent" />}>
                    <Outlet />
                </Suspense>
            </div>
        </div>
    );
};

export default Layout;
